module.exports = __webpack_public_path__ + "static/media/Hohe-qualitaet1.fc8820f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/photos/Hohe-qualitaet1.jpg
// module id = 229
// module chunks = 8